import { render } from "./LearnAboutGideons.vue?vue&type=template&id=03889e2a&scoped=true"
import script from "./LearnAboutGideons.vue?vue&type=script&lang=js"
export * from "./LearnAboutGideons.vue?vue&type=script&lang=js"

import "./LearnAboutGideons.vue?vue&type=style&index=0&id=03889e2a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03889e2a"]])

export default __exports__